import React, { useEffect, useRef, useState } from "react";
import "../../styles/Dashboardpage.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Footer from "../../components/Footer/Footer";
import { AreaChart, Area } from "recharts";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import DashsideIcon from "../../assets/Images/side.webp";
import DashbiardCreditDebit from "../../assets/Images/DashboardcredDebit.png";
import Bliz from "../../assets/Images/bliz.png";
import DBCreditcard from "../../assets/Images/DBcreditedIcon.webp";
import electricity from "../../assets/Images/Electricity.webp";
import DBpayhouse from "../../assets/Images/DBpayhouse.webp";
import axios from "axios";
import {
  GetRegisteredMobileNumber,
  GetWebAccessToken,
} from "../../components/ReusebleComponents/ResuseableApiCalls";
import NtarLoader from "../../components/Loaders/NtarLoader";
import Header from "../../components/Header/Header";
import { data } from "../../Common/Text/NormalText";
import {
  isFeatureActive,
  isFeatureServiceActive,
} from "../../Common/serviceActiveCheck/serviceActiveCheck";
import { path } from "../../routes/Paths";
import Call_Api from "../../Common/Handileapi/Call_api";
import { getImage } from "../../Common/creditCardBinAPI/CommonFunctions";
import Lottie from "lottie-react";
import { ImagesPath } from "../../Common/imagespath/imagespath";
import {
  clearDetailsToSend,
  setDetailsToSend,
} from "../../redux/slice/detailsToSendSlice";

const baseUrl = process.env.REACT_APP_BACKEND_URL;
const dummyData = [
  { value: 10 },
  { value: 30 },
  { value: 50 },
  { value: 40 },
  { value: 70 },
  { value: 90 },
];

const Dashboardpage = () => {
  const navigate = useNavigate();
  const detailsToSend = useSelector((state) => state?.details?.details);
  const [monthWiseTransactionData, setMonthWiseTransactinData] = useState({});
  const [customLinkData, setCustomLinkData] = useState({});
  const [customLinkResData, setCustomLinkResData] = useState({});
  const [amount, setAmount] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const userDetails = useSelector((state) => state.user.user);
  const features = useSelector((state) => state.activeFeatures.features);
  const [recentBbpsTransactions, setRecentBbpsTransactions] = useState([]);
  const [recentTransferTransactions, setRecentTransferTransactions] =
    useState();
  const [selectedDate, setSelectedDate] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  const dispatch = useDispatch();
  const currentMonth = new Date().getMonth() + 1;
  const [selectedMonth, setSelectedMonth] = useState(currentMonth - 1);
  const settlementLoadingRef = useRef(false);

  const handleSettlementClick = async () => {
    if (settlementLoadingRef.current) return;

    settlementLoadingRef.current = true;

    const unSettledAmount = await getT1andT2();

    localStorage.setItem("selectedMenu", "Settlements");

    navigate("/SettlementDetails", {
      state: {
        unsettledBalance: !isNaN(parseFloat(unSettledAmount))
          ? parseFloat(unSettledAmount)
          : 0,
        balance: userDetails?.walletBalance,
        serviceName: "Settlements",
        transferAmount: amount,
      },
    });

    settlementLoadingRef.current = false;
  };

  const getT1andT2 = async () => {
    const TIMEOUT = 4000; // 4 seconds

    const timeoutPromise = new Promise((resolve) => {
      setTimeout(() => resolve(0), TIMEOUT);
    });

    const apiCall = (async () => {
      try {
        const start = Date.now();
        const token = await GetWebAccessToken();
        const t1andt2 = await Call_Api(
          path.GET_T1_AND_T2_TRANSACTIONS,
          "GET",
          {},
          token
        );
        const end = Date.now();
        console.log("API time to fetch the t1t2 data ==>", end - start);

        if (t1andt2?.success) {
          return t1andt2?.response?.totalAmount ?? 0;
        }
        return 0;
      } catch (error) {
        return 0;
      }
    })();

    return Promise.race([apiCall, timeoutPromise]);
  };

  const handleToggle = (option) => {
    setSelectedOption(option); // Update the selected option
  };

  const [selectedOption, setSelectedOption] = useState("credited"); // Default to "Credited"

  const weeklyKeys = ["1", "2", "3", "4", "5"];
  const monthlyData = weeklyKeys.map((key) => {
    const weekData = monthWiseTransactionData[key] || {
      creditedAmount: 0,
      debitedAmount: 0,
    };

    return {
      week: `Week ${key}`,
      credited: weekData.creditedAmount || 0,
      debited: weekData.debitedAmount || 0,
    };
  });

  const months = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "july", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
  ];

  const handleGetMonthWiseData = async () => {
    const token = await GetWebAccessToken();
    let headers = {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Authorization: `Bearer ${token}`,
    };
    try {
      setIsFetching(true);
      const res = await axios.get(
        `${baseUrl}/transactions/getyearWise/monthWise/weekWise/creditDebitTransaction?month=${selectedMonth}`,
        { headers }
      );
      if (res.status === 200 && res.data) {
        setMonthWiseTransactinData(res.data);
      } else {
        setMonthWiseTransactinData({});
      }
    } catch (error) {
      console.log("error while fetching the month wise date===>", error);
    } finally {
      setIsFetching(false);
    }
  };
  useEffect(() => {
      handleGetMonthWiseData();
  }, [selectedMonth]);

  const handleGetCustomLinkData = async () => {
    const token = await GetWebAccessToken();
    let headers = {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Authorization: `Bearer ${token}`,
    };
    try {
      setIsFetching(true);
      const res = await axios.get(
        `${baseUrl}/transactions/monthlyWise/customLinkTrnx`,
        { headers }
      );
      if (res.status === 200 && res.data) {
        let yearlyData = [
          { label: "Jan", value: "0" },
          { label: "Feb", value: "1" },
          { label: "Mar", value: "2" },
          { label: "Apr", value: "3" },
          { label: "May", value: "4" },
          { label: "Jun", value: "5" },
          { label: "Jul", value: "6" },
          { label: "Aug", value: "7" },
          { label: "Sep", value: "8" },
          { label: "Oct", value: "9" },
          { label: "Nov", value: "10" },
          { label: "Dec", value: "11" },
        ];

        let customLinkResData = res.data;

        let updatedYearlyData = yearlyData.map((eachMonth) => {
          const monthIndex = eachMonth.value;
          const monthData = customLinkResData[monthIndex];
          if (monthData) {
            return {
              month: eachMonth.label,
              linksCount: monthData.totaltrnx,
              money: monthData.successTrnx,
            };
          } else {
            return {
              month: eachMonth.label,
              linksCount: 0,
              money: 0,
            };
          }
        });
        setCustomLinkData(updatedYearlyData);
        setCustomLinkResData(customLinkResData);
      } else {
        setCustomLinkData({});
      }
    } catch (error) {
      console.log("error while fetching the month wise date===>", error);
    } finally {
      setIsFetching(false);
    }
  };

  const fetchSettlementTransactions = async () => {
    const token = await GetWebAccessToken();
    const headers = {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await axios.get(
        `${apiUrl}/transactions/get/SelfTransferTransactions/service/subService?serviceName=Settlements&subService=Transfer&filterType=${
          selectedDate === "All" ? "" : selectedDate
        }&fromDate=${startDate}&toDate=${endDate}&payOutStatus=${
          selectedStatus === "All" ? "" : selectedStatus?.toUpperCase()
        }`,
        { headers }
      );
      if (response?.data?.message === "valid") {
        const paymentTransactions = response?.data?.data;
        setRecentTransferTransactions(paymentTransactions);
      } else {
        setRecentTransferTransactions([]);
      }
    } catch (error) {
      console.log("error while fetching payment link details===>", error);
      setRecentTransferTransactions([]);
    }
  };

  useEffect(() => {
    // if(!userDetails?.IpayOutletId){
    //   navigate("/kycScreen")
    // }
    if (userDetails?.walletStatus?.toLowerCase() == "active") {
      handleGetCustomLinkData();
      fetchSettlementTransactions();
    }
    handleGetBbpsTransactions();
    dispatch(clearDetailsToSend());
    localStorage.removeItem("CONTACT_DETAILS_FLOW");
    sessionStorage.clear();
    sessionStorage.removeItem("origin"); 
    localStorage.removeItem("cashfreeWebData");
    localStorage.removeItem("cashfreeFastagData");
    localStorage.removeItem("razorpayData");
    localStorage.removeItem("transactionData");
    localStorage.removeItem("paymentData");
    localStorage.removeItem("phonepeData");
    localStorage.removeItem("payUData");
  }, []);

  const handleGetBbpsTransactions = async () => {
    const token = await GetWebAccessToken();
    try {
      const response = await axios.get(
        `${apiUrl}/bbpsPaymentsTrasanctions/transactions/${userDetails?.MerchantId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      const Details = response.data;
      if (Details.success) {
        setRecentBbpsTransactions(Details?.data);
      }
    } catch (error) {
      console.log(
        " error while fetching cetns detailsof bbps transaction ",
        error.message
      );
    }
  };

  const formatNumber = (num, service = "") => {
    if (num == null || isNaN(num)) {
      num = 0;
    }

    let formatted = num;
    let isAbbreviated = false;

    if (num >= 1_000_000) {
      formatted = (num / 1_000_000).toFixed(2) + "M";
      isAbbreviated = true;
    } else if (num >= 1_000) {
      formatted = (num / 1_000).toFixed(2) + "k";
      isAbbreviated = true;
    }

    if (service?.toLowerCase() === "transfer") {
      return isAbbreviated ? formatted : Number(num);
    } else {
      return isAbbreviated ? formatted : Number(num).toFixed(2);
    }
  };

  const handleNavigateToBbps = (text) => {
    dispatch(
      setDetailsToSend({
        ...detailsToSend,
        payOutFee: "0",
        payOutPercentage: 0,
        payOutChargedAmount: 0,
        chargedAmount: 0,
        creditCardNumber: "",
        paymentSource: "webApp",
        serviceName: text?.split("/")?.[2],
      })
    );
    navigate(text);
  };

  return (
    <>
      <Header title="Dashboard" />
      {isFetching ? (
        <NtarLoader />
      ) : (
        <div className="db-main">
          <div className="db-main__container">
            <div className="db-content">
              <div className="db-monthly">
                <div className="db-monthly__header">
                  <div className="db-monthly__selector">
                    <span className="db-monthly__label">{data?.monthlyV}</span>
                    <select
                      className="db-monthly__select"
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                    >
                      {months?.slice(0, currentMonth).map((month) => (
                        <option key={month?.value} value={month?.value}>
                          {month?.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="db-transactions">
                    {/* Credited Card */}
                    <div
                      className={`db-transactions_card ${
                        selectedOption === "credited"
                          ? "db-transactions__card--credit"
                          : "db-transactions__card--debit"
                      }`}
                      onClick={() => handleToggle("credited")}
                    >
                      <img
                        className="Db-credDebImg"
                        src={DBCreditcard}
                        alt="Credit/Debit"
                      />
                      <div className="db-bothlabels">
                        <span
                          className={
                            selectedOption === "credited"
                              ? "db-transactions__label"
                              : "db-transactions__label__Credited"
                          }
                        >
                          {data?.cr}
                        </span>
                        <div className="db-transactions__amount">
                          + ₹{" "}
                          {formatNumber(
                            monthWiseTransactionData["totalCreditTrnx"]
                          ) || 0}
                        </div>
                      </div>
                    </div>

                    <div
                      className={`db-transactions_card ${
                        selectedOption === "debited"
                          ? "db-transactions__card--credit"
                          : "db-transactions__card--debit"
                      }`}
                      onClick={() => handleToggle("debited")}
                    >
                      <img
                        className="Db-credDebImg"
                        src={DashbiardCreditDebit}
                        alt="Credit/Debit"
                      />
                      <div className="db-bothlabels">
                        <span
                          className={
                            selectedOption === "debited"
                              ? "db-transactions__label"
                              : "db-transactions__label__Debited"
                          }
                        >
                          {data?.dr}
                        </span>
                        <div className="db-transactions__amount">
                          - ₹{" "}
                          {formatNumber(
                            monthWiseTransactionData?.["totalDebitTrnx"]
                          ) || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="db-chart">
                  <ResponsiveContainer width="100%" height={275}>
                    <LineChart
                      data={monthlyData}
                      margin={{ top: 20, right: 20, left: 40, bottom: 30 }}
                    >
                      <XAxis
                        dataKey="week"
                        tick={{ fontSize: 12, fill: "var(--black)" }}
                        padding={{ left: 20, right: 20 }}
                        axisLine={{ stroke: "var(--black)" }}
                        tickLine={{ stroke: "var(--black)" }}
                      />
                      <YAxis
                        // domain={[0, 1500000]}
                        ticks={[
                          100000, 1000000, 2000000, 3000000, 4000000, 5000000,
                        ]}
                        tickFormatter={(value) => `${value / 100000}L`}
                        tick={{ fontSize: 12, fill: "var(--black)" }}
                        axisLine={{ stroke: "var(--black)" }}
                        tickLine={{ stroke: "var(--black)" }}
                      />
                      <Tooltip />
                      <Legend />
                      <Line
                        type="basis"
                        dataKey="credited"
                        stroke={
                          selectedOption === "credited" ? "#0E9C4A" : "#ccc"
                        }
                        strokeWidth={selectedOption === "credited" ? 2 : 1}
                        dot={{ r: selectedOption === "credited" ? 4 : 0 }}
                        activeDot={{ r: 6 }}
                      />
                      <Line
                        type="basis"
                        dataKey="debited"
                        stroke={
                          selectedOption === "debited" ? "#FF6600" : "#ccc"
                        }
                        strokeWidth={selectedOption === "debited" ? 2 : 1}
                        dot={{ r: selectedOption === "debited" ? 4 : 0 }}
                        activeDot={{ r: 6 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>

              <div className="db-notifications">
                <div className="db-notifications__header">
                  <h2 className="db-notifications__title">{data?.notifi}</h2>
                  <button
                    style={{ color: "var(--black)" }}
                    className="db-notifications__clear"
                    onClick={() => setRecentBbpsTransactions([])}
                  >
                    <DeleteOutlineIcon style={{ color: "#F94327" }} />{" "}
                    {data?.clear}
                  </button>
                </div>
                <div className="db-notifications__list">
                  {recentBbpsTransactions
                    ?.slice(-4)
                    ?.map((notification, index) => (
                      <div key={index} className="db-notifications__item">
                        <div className="db-notifications__icon">
                          <img
                            src={
                              notification?.serviceName?.toLowerCase() ==
                              "mobile prepaid"
                                ? getImage(notification?.subService)
                                : notification?.detailsToSend?.Operator
                                    ?.billLogo || notification?.billerLogo
                            }
                            alt="No Image"
                            height={30}
                            width={30}
                            style={{ borderRadius: "15px" }}
                          />
                        </div>
                        <div className="db-notifications__content">
                          <span className="db-notifications__text">
                            {notification?.detailsToSend?.Operator
                              ?.billerCategory || notification?.serviceName}
                            {"\u00A0"}
                            {(notification?.detailsToSend?.creditCardNumber ||
                              notification?.creditCardNumber) &&
                            notification?.serviceName?.toLowerCase() ==
                              "credit card"
                              ? `XXXXXXXX${(notification?.creditCardNumber
                                  ? notification?.creditCardNumber
                                  : notification?.detailsToSend
                                      ?.creditCardNumber
                                )?.slice(-4)}`
                              : notification?.subService ||
                                Object.values(
                                  notification?.detailsToSend?.inputParams || {}
                                )[0]}
                          </span>
                        </div>
                        <button
                          className="db-notifications__pay-btn"
                          onClick={() => {
                            dispatch(
                              setDetailsToSend({
                                ...detailsToSend,
                                payOutFee: "0",
                                payOutPercentage: 0,
                                payOutChargedAmount: 0,
                                chargedAmount: 0,
                                creditCardNumber: "",
                                paymentSource: "webApp",
                                serviceName:
                                  notification?.detailsToSend?.Operator
                                    ?.billerCategory ||
                                  notification?.serviceName,
                              })
                            );
                            navigate(
                              `/bbps/${
                                notification?.detailsToSend?.Operator
                                  ?.billerCategory || notification?.serviceName
                              }`
                            );
                          }}
                        >
                          {data?.pNow}
                        </button>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="db-quick-actions">
              {userDetails?.walletStatus?.toLowerCase() == "active" &&
              userDetails?.walletStatus ? (
                <div className="db-quick-actions__card db-wallet">
                  <div className="db-quick-actions__header">
                    <span>{data?.walletBal}</span>
                    <img
                      className="dashsideicon-db"
                      src={DashsideIcon}
                      alt="sidemenuicon"
                      onClick={() => navigate("/Settlement")}
                    />
                  </div>
                  <div className="db-wallet__balance">
                    <span className="db-rupee-v">₹ </span>
                    {userDetails?.walletStatus?.toLowerCase() == "active"
                      ? formatNumber(monthWiseTransactionData["walletBlnce"]) ||
                        0
                      : 0}
                  </div>
                  <div className="db-wallet__charts">
                    {/* Green Chart */}
                    <ResponsiveContainer width="45%" height={80}>
                      <AreaChart data={dummyData}>
                        <Area
                          type="monotone"
                          dataKey="value"
                          stroke="green"
                          fill="lightgreen"
                        />
                      </AreaChart>
                    </ResponsiveContainer>

                    {/* Orange Chart */}
                    <ResponsiveContainer width="45%" height={80}>
                      <AreaChart data={dummyData}>
                        <Area
                          type="monotone"
                          dataKey="value"
                          stroke="orange"
                          fill="salmon"
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              ) : (
                <div className="db-quick-actions__card db-wallet">
                  <div className="db-quick-actions__header">
                    <span>{data?.Electricity}</span>
                    <img
                      className="dashsideicon-db"
                      src={DashsideIcon}
                      alt="sidemenuicon"
                      onClick={() => handleNavigateToBbps("/bbps/Electricity")}
                    />
                  </div>
                  {/* <div className="db-wallet__balance">
                  <span className="db-rupee-v">₹ </span>
                  {userDetails?.walletStatus?.toLowerCase() == "active" ? formatNumber(monthWiseTransactionData["walletBlnce"]) || 0 : 0}
                </div> */}
                  <div className="db-wallet__charts">
                    <Lottie
                      animationData={ImagesPath?.ElectricityAnime}
                      loop={true}
                    />
                  </div>
                </div>
              )}

              {userDetails?.walletStatus?.toLowerCase() == "active" &&
              userDetails?.walletStatus ? (
                <div className="db-quick-actions__card db-quick-send">
                  <div className="db-quick-actions__header">
                    <span>{data?.quick}</span>
                    {/* <ArrowForwardIcon /> */}
                    <img
                      className="dashsideicon-db"
                      src={DashsideIcon}
                      alt="sidemenuicon"
                      onClick={() => handleSettlementClick()}
                    />
                  </div>
                  <div className="db-quick-send__input">
                    <span>{data?.enterAmount}</span>
                    <input
                      type="text"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      placeholder="0"
                    />
                  </div>
                  <div className="db-quick-send__users">
                    <span>{data?.recentU}</span>
                    <div className="db-quick-send__avatars">
                      <AvatarGroup
                        max={7}
                        className="db-quick-send__avatar-group"
                      >
                        {recentTransferTransactions?.length > 0 ? (
                          recentTransferTransactions
                            .slice(0, 2)
                            .map((trans) => (
                              <Avatar
                                key={trans.id}
                                className="db-quick-send__avatar"
                              >
                                {formatNumber(trans.actualAmount, "transfer") ??
                                  "N/A"}
                              </Avatar>
                            ))
                        ) : (
                          <p>{data?.noTrans}</p>
                        )}
                      </AvatarGroup>
                      <button className="db-quick-send__add">
                        <MoreHorizIcon />
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="db-quick-actions__card db-quick-send">
                  <div className="db-quick-actions__header">
                    <span>{data?.Fastag}</span>
                    <img
                      className="dashsideicon-db"
                      src={DashsideIcon}
                      alt="sidemenuicon"
                      onClick={() => handleNavigateToBbps("/bbps/FastTag")}
                    />
                  </div>
                  <div className="lottie-road-container">
                    <Lottie
                      animationData={ImagesPath?.FasttagAnime}
                      loop={true}
                      className="lottie_animation"
                    />
                    {/* <img
                      src={ImagesPath?.road}
                      alt="fastag"
                      className="road_s"
                    /> */}
                  </div>
                </div>
              )}

              <div className="db-quick-actions__card-creditcardimg db-credit-card">
                <div className="db-quick-actions__header">
                  <span>{data?.creditBill}</span>
                  <img
                    onClick={() => navigate("/CreditCardBillPayments")}
                    className="dashsideicon-db"
                    src={DashsideIcon}
                    alt="sidemenuicon"
                  />
                </div>
                <div className="db-credit-card__visual">
                  <Lottie
                    animationData={ImagesPath?.creditCardAnime}
                    loop={true}
                  />
                  {/* <img className="DB-cards" src={dbcards} /> */}
                </div>
              </div>

              <div className="db-quick-actions__card_qr db-qr">
                <div className="db-qr-content">
                  <div className="db-qr-header">
                    <span style={{ fontWeight: "bold" }}>{data?.actQ}</span>
                    <div onClick={() => navigate("/ActiveQR")}>
                      <img
                        onClick={() => navigate("/ActiveQR")}
                        className="dashsideicon-db"
                        src={DashsideIcon}
                        alt="sidemenuicon"
                      />
                    </div>
                  </div>
                  <div className="db-qr-image">
                    <Lottie
                      animationData={ImagesPath?.QrAnime}
                      loop={true}
                      className="qr-background"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="db-stats">
              {userDetails?.walletStatus?.toLowerCase() == "active" &&
                userDetails?.walletStatus && (
                  <div className="DB-settlement-status-card">
                    <div className="DB-wave-background"></div>
                    <div className="status-content">
                      <div className="settlement-header">
                        <h2 className="settlement_header">
                          {data?.settlement}
                          {userDetails?.allowWalletSettlements?.includes(
                            "Settlements"
                          ) &&
                          userDetails?.walletStatus?.toLowerCase() ==
                            "active" &&
                          isFeatureServiceActive(
                            features,
                            "Settlements",
                            "Transfer"
                          )
                            ? " Enabled"
                            : " Not Enabled"}
                        </h2>
                        <label className="toggle-switch">
                          <input
                            type="checkbox"
                            readOnly
                            checked={
                              userDetails?.allowWalletSettlements?.includes(
                                "Settlements"
                              ) &&
                              userDetails?.walletStatus?.toLowerCase() ==
                                "active" &&
                              isFeatureServiceActive(
                                features,
                                "Settlements",
                                "Transfer"
                              )
                                ? true
                                : false
                            }
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </div>
                      <div className="payment-info">
                        <button
                          className="settlementnew-button"
                          onClick={handleSettlementClick}
                          disabled={
                            !userDetails?.allowWalletSettlements?.includes(
                              "Settlements"
                            ) ||
                            userDetails?.walletStatus?.toLowerCase() !=
                              "active" ||
                            !isFeatureServiceActive(
                              features,
                              "Settlements",
                              "Transfer"
                            )
                          }
                        >
                          {data?.settlement}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

              {userDetails?.walletStatus?.toLowerCase() == "active" &&
                userDetails?.walletStatus && (
                  <div className="db-stats__card db-links">
                    <div className="db-links__header">
                      <div className="db-links__legend">
                        <div className="db-links__legend-item">
                          <span className="db-links__dot db-links__dot--purple"></span>
                          <span className="db-links_dot db-links_dot--purple"></span>
                          <span>{data?.throughLink}</span>
                        </div>
                        <div className="db-links__legend-item">
                          <span className="db-links__dot db-links__dot--blue"></span>
                          <span className="db-links_dot db-links_dot--blue"></span>
                          <span>{data?.CollectedMoney}</span>
                        </div>
                      </div>
                    </div>

                    <div className="db-links__stats-chart2">
                      <div className="graph-chart-db">
                        <img className="db-bliz-img" src={Bliz} />
                        <div className="db-links__stats">
                          <div className="db-links__stat">
                            <span>{data?.throughLink}</span>
                            <div className="db-links__number">
                              {customLinkResData?.totalTrnx}
                            </div>
                          </div>
                          <div className="db-links__stat">
                            <span>{data?.totalLinkMoney}</span>
                            <div className="db-links__number">
                              ₹ {customLinkResData?.totalSuccessTrnx}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="db-links__chart">
                        <ResponsiveContainer width="100%" height={100}>
                          <BarChart data={customLinkData} barSize={8}>
                            <XAxis
                              dataKey="month"
                              axisLine={false}
                              tickLine={false}
                              tick={{ fontSize: 12, fill: "#666" }}
                              interval={0}
                              angle={-45}
                              textAnchor="end"
                            />
                            <Tooltip />

                            <Bar
                              dataKey="linksCount"
                              fill="#7C5CFC"
                              radius={[4, 4, 0, 0]}
                              minPointSize={1}
                            />

                            <Bar
                              dataKey="money"
                              fill="#0867E1"
                              radius={[4, 4, 0, 0]}
                              minPointSize={1}
                            />
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Dashboardpage;
